'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reactScroll = require('react-scroll');
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _contactUs = require('../../redux/modules/contactUs');
var _messageModal = require('../../redux/modules/messageModal');

var _scrollTo = require('../../utils/scrollTo');var _scrollTo2 = _interopRequireDefault(_scrollTo);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _constants = require('../../constants');
var _validate = require('../../utils/validate');

var _ContactUsFormContainer = require('./ContactUsFormContainer.scss');var styles = _interopRequireWildcard(_ContactUsFormContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helper
// Styles
_reactScroll.scroller.scrollTo = _scrollTo2.default.bind(_reactScroll.scroller);var requiredFields = function requiredFields(usage) {return usage === _constants.contactUsUsage.agent || usage === _constants.contactUsUsage.realtorPackages ? ['name', 'email', 'phone', 'captchaToken', 'companyName'] : ['name', 'email', 'subject', 'message', 'captchaToken'];};var


ContactUsFormContainer = function (_Component) {_inherits(ContactUsFormContainer, _Component);function ContactUsFormContainer() {var _temp, _this, _ret;_classCallCheck(this, ContactUsFormContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      formData: {},
      invalidFields: [],
      showPreloader: false }, _this.


    componentWillReceiveProps = function (_ref) {var contactUs = _ref.contactUs,isMessageModalOpen = _ref.isMessageModalOpen;
      var stateModifier = {};

      if (contactUs.loading !== _this.props.contactUs.loading) {
        stateModifier.showPreloader = contactUs.loading;
      }

      if (contactUs.loaded && contactUs.loaded !== _this.props.contactUs.loaded) {
        _this.props.openMessageModal({
          message:
          _react2.default.createElement('div', { className: 'contentMessage' },
            _react2.default.createElement('div', null,
              _react2.default.createElement('p', null, _this.props.translate('contactUsPage', 'formSent')),
              _react2.default.createElement('button', {
                  className: 'btn btn-primary',
                  onClick: _this.handleModalsClose },

                _this.props.translate('contactUsPage', 'ok')))),




          isCloseButtonInvisible: true });

      }

      if (contactUs.error && contactUs.error !== _this.props.contactUs.error) {
        _this.props.openMessageModal({
          message:
          _react2.default.createElement('div', { className: 'contentMessage' },
            _react2.default.createElement('div', null,
              _react2.default.createElement('p', null, _this.props.translate('contactUsPage', 'error')),
              _react2.default.createElement('button', {
                  className: 'btn btn-primary',
                  onClick: _this.handleModalsClose },

                _this.props.translate('contactUsPage', 'ok')))) });





      }

      if (!isMessageModalOpen && contactUs.loaded && _this.props.isMessageModalOpen) {
        _this.contactUsForm.reset();
        if (!_this.props.isNative) {
          if (_this.props.usage === _constants.contactUsUsage.agent || _this.props.usage === _constants.contactUsUsage.realtorPackages) {
            _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/'));
          } else if (_this.props.usage === _constants.contactUsUsage.modal) {
            _this.props.hideContactUsModal();
            return;
          } else {
            _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/'));
          }
        }
      }

      if (Object.keys(stateModifier).length) {
        _this.setState(stateModifier);
      }
    }, _this.

    mdFiles = __CLIENT__ ? require.context('../../translations/publishContactUs/') : function () {}, _this.

    handleModalsClose = function () {
      _this.props.hideMessageModal();
      if (_this.props.isContactUsModalOpen) {
        _this.props.hideContactUsModal();
      }
    }, _this.

    handleChange = function (evt) {var _evt$target =
      evt.target,name = _evt$target.name,value = _evt$target.value;
      _this.saveFormData(name, value);
    }, _this.

    fetchReCaptchaToken = function (token) {
      _this.saveFormData('captchaToken', token);
      _this.sendFormData(_this.state.formData);
    }, _this.

    saveFormData = function (name, value) {var _Object$assign;
      var invalidFields = [].concat(_this.state.invalidFields);
      var index = invalidFields.indexOf(name);
      var formData = Object.assign({},
      _this.state.formData, (_Object$assign = {}, _Object$assign[
      name] = value, _Object$assign));


      if (index !== -1 && _this.validateField(name, formData)) {
        invalidFields.splice(index, 1);
      }

      _this.setState({
        invalidFields: invalidFields,
        formData: formData });

    }, _this.

    handleSubmit = function (evt) {
      evt.preventDefault();
      var invalidFields = _this.findInvalidRequiredFields();
      _this.setState({ invalidFields: invalidFields });
      if (!invalidFields.length) {
        _this.sendFormData(_this.state.formData);
      } else if (invalidFields.length === 1 && invalidFields[0] === 'captchaToken') {
        return true; // Request captcha
      } else {
        _this.scrollToInvalidField(invalidFields[0]);
      }
      return undefined;
    }, _this.

    sendFormData = function (_ref2)








    {var name = _ref2.name,message = _ref2.message,email = _ref2.email,phone = _ref2.phone,title = _ref2.subject,captcha = _ref2.captchaToken,companyName = _ref2.companyName,package_name = _ref2.package_name;
      var params = Object.assign({
        name: name,
        title: title,
        message: message,
        captcha: captcha,
        email: email.toLowerCase() },
      phone ? { phone: phone } : {},
      _this.props.userData && _this.props.userData.id ? { user_id: _this.props.userData.id } : {},
      companyName && { company_name: companyName },
      package_name ? { package_name: package_name } : {});

      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.contactUs, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.contactUs);
      _this.props.sendContactUsForm({
        data: params,
        isRealtor: _this.props.usage === _constants.contactUsUsage.agent || _this.props.usage === _constants.contactUsUsage.realtorPackages });

    }, _this.

    findInvalidRequiredFields = function () {var
      formData = _this.state.formData;
      return requiredFields(_this.props.usage).filter(function (item) {return !_this.validateField(item, formData);});
    }, _this.

    validateField = function (name, formData) {
      var fieldIsValid = void 0;

      switch (name) {
        case 'email':{
            fieldIsValid = (0, _validate.emailRegexValidation)(formData[name]);
            break;
          }
        default:fieldIsValid = !!formData[name];}


      return fieldIsValid;
    }, _this.

    fieldIsInvalid = function (name) {return _this.state.invalidFields.indexOf(name) !== -1;}, _this.

    scrollToInvalidField = function (fieldName) {
      _reactScroll.scroller.scrollTo(fieldName, {
        duration: 500,
        offset: _this.props.isMobile ? -47 : 0,
        smooth: true,
        containerSelector: _this.props.isMobile ? '#app' : null,
        containerId: _this.props.isMobile ? 'app' : null });

    }, _temp), _possibleConstructorReturn(_this, _ret);}ContactUsFormContainer.prototype.

  render = function render() {var _cx,_this2 = this;
    var formTitle = this.props.translate('contactUsPage', 'formTitle');
    switch (this.props.usage) {
      case _constants.contactUsUsage.agent:
        formTitle =
        _react2.default.createElement('div', { className: styles.agentDescription },
          _react2.default.createElement('span', { className: styles.formTitle }, this.props.translate('contactUsPage', 'advertiseHere')));


        break;
      case _constants.contactUsUsage.realtorPackages:
        formTitle =
        _react2.default.createElement('h2', null, this.props.translate('contactUsPage', 'placeOrder').toUpperCase());

        break;
      case _constants.contactUsUsage.projects:
        formTitle = this.props.translate('contactUsPage', 'formTitleProjects');
        break;
      default:
        break;}

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(
          'contact-us-form-container',
          styles.container, (_cx = {}, _cx[
          styles.contactUsRealtor] = this.props.isPageForRealtor, _cx)) },


        _react2.default.createElement('div', { className: styles.formTitle }, formTitle),
        _react2.default.createElement('form', { ref: function ref(contactUsForm) {_this2.contactUsForm = contactUsForm;} },
          _react2.default.createElement(_components.UserDetailsSection, {
            translate: this.props.translate('contactUsPage', 'userDetailsSection'),
            fieldIsInvalid: this.fieldIsInvalid,
            handleChange: this.handleChange,
            isMobile: this.props.isMobile,
            className: 'contactUsForm',
            isRtl: this.props.isRtl,
            usage: this.props.usage,
            isPageForRealtor: this.props.isPageForRealtor }),

          _react2.default.createElement(_components.MessageSection, {
            translate: this.props.translate('contactUsPage', 'messageSection'),
            locale: this.props.locale,
            handleChange: this.handleChange,
            fieldIsInvalid: this.fieldIsInvalid,
            fetchReCaptchaToken: this.fetchReCaptchaToken,
            className: 'contactUsForm',
            showPreloader: this.state.showPreloader,
            onSubmit: this.handleSubmit,
            isRtl: this.props.isRtl,
            usage: this.props.usage })),


        this.props.isPageForRealtor &&
        _react2.default.createElement('div', { className: styles.contactPhone },
          _react2.default.createElement('a', { href: 'tel:' + _constants.ourContacts.phone, 'data-rel': 'external' }, this.props.translate('realtorInfoPage', 'callUs'), ' ', _constants.ourContacts.phone))));




  };return ContactUsFormContainer;}(_react.Component);


ContactUsFormContainer.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  sendContactUsForm: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  contactUs: _propTypes2.default.object,
  isMessageModalOpen: _propTypes2.default.bool,
  usage: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  isContactUsModalOpen: _propTypes2.default.bool,
  hideContactUsModal: _propTypes2.default.func,
  isPageForRealtor: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userData: state.userAuthentication.data,
    contactUs: state.contactUs,
    isMessageModalOpen: state.messageModal.isMessageModalOpen };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  sendContactUsForm: _contactUs.sendContactUsForm,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal })(
ContactUsFormContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ContactUsForm/ContactUsFormContainer.js
// module id = 2896
// module chunks = 0